/**
 * BackgroundCheckController Controller
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Aditya
 */
angular.module('flsControllers').controller('BackgroundCheckController', [
    '$scope',
    'BackgroundCheck',
    'Certification',
    function($scope, BackgroundCheck, Certification){

    // Set the Loading state
    $scope.loading = false;

    // Set loading state to false
    $scope.loaded = false;

    // Init the Background Check
    $scope.bgc = {};

    // Init the counter of Unique Providers
    $scope.providersCount = 0;

    // Init the can_complete flag
    $scope.can_complete = false;


    // Init the Controller with the BGCID
    $scope.init = function(id, providersCount) {
        // Set loading state to true
        $scope.loading = true;

        // Set loading state to true
        $scope.providersCount = providersCount || $scope.providersCount;

        BackgroundCheck.get({id:id}, function(resource){
            // Set the BGC
            $scope.bgc = resource.data;
            // Set the loaded flag
            $scope.loaded = true;

            $scope.can_complete = $scope.canCompleteCertification();
        }, function($error){
            _.each($error.data, function(error){
                $.publish('resource.error', error);
            });
        });

        // Set loading state to false
        $scope.loading = false;
    }

    // Check if the Certification exists
    $scope.hasCertification = function(id) {
        return !angular.equals({}, $scope.getCertification(id));
    }


    // Get Certification by certification_type_id
    $scope.getCertification = function(id) {
        // Copy the BGC
        var $bgc = angular.copy($scope.bgc);
        // Define Result
        var $result = {};
        // iterate through $bgc.certifications to find the one with certification_type_id
        angular.forEach($bgc.certifications, function(certification, index) {
            if(id === certification.certification_type_id) {
                $result = certification;
            }
        });

        return $result;
    }

    // Certify within BackgrounCheck
    $scope.certify = function(id, creator) {
        // Copy the BGC
        var $bgc = angular.copy($scope.bgc);
        // Make the Certification
        var $certification = angular.extend({certification_type_id:id, creator:creator}, $scope.makeContext());
        // Create new Certification
        // Refresh BGC
        Certification.save($certification, function(response){
            if(response){
                // Load the notes in context
                $scope.init($bgc.id);
            } else {
                /*display an error maybe? */
            };
        }, function($error){
            _.each($error.data, function(error){
                $.publish('resource.error', error);
            });
        });
    }


    // Make context for the BGC
    $scope.makeContext = function(){
        // Copy the BGC
        var $bgc = angular.copy($scope.bgc);

        return {
            context_type:$bgc.morph_class,
            context_id:$bgc.id
        };
    }


    // True if the user can complete Certification
    $scope.canCompleteCertification = function(){
        // Copy the BGC
        var $bgc = angular.copy($scope.bgc);
        // create a lookup
        var $lookup = {};

        angular.forEach($bgc.certifications, function(certification){
            $lookup[certification.certification_type_id] = certification;
        });

        return Object.keys($lookup).length == $scope.providersCount;
    }


    // Complete ehte BGC
    $scope.complete = function(model, evaluator_id){
        // Copy the BGC
        var $bgc = angular.copy($scope.bgc);

        var $completed = {
            completed_at:moment().format(),
        };

        // Do the update
        BackgroundCheck.update({id:$bgc.id, evaluator_id:evaluator_id},$completed, function(response){
            if(response){
                // Load the notes in context
                $scope.init($bgc.id);
            } else {
                /*display an error maybe? */
            };
        })
    }
}]);
